module.exports = {
          srcSet: __webpack_public_path__ + "public/images/1f80894f7025b63a38f7d2c836227b2b-1536.webp"+" 1536w",
          images:[ {path: __webpack_public_path__ + "public/images/1f80894f7025b63a38f7d2c836227b2b-1536.webp",width: 1536,height: 1024}],
          src: __webpack_public_path__ + "public/images/1f80894f7025b63a38f7d2c836227b2b-1536.webp",
          toString:function(){return __webpack_public_path__ + "public/images/1f80894f7025b63a38f7d2c836227b2b-1536.webp"},
          
          width: 1536,
          height: 1024
        }